const SIZE_DATA = [
  { size: 'S', height: [160, 170], weight: [50, 65] },
  { size: 'M', height: [168, 178], weight: [65, 75] },
  { size: 'L', height: [175, 185], weight: [75, 85] },
  { size: 'XL', height: [182, 195], weight: [85, 100] },
];

const dialog = document.querySelector('#size-chart-modal');
let lastTrigger;

function setActiveTab(name) {
  if (!dialog) return;

  dialog.querySelectorAll('[data-size-chart-tab]').forEach((tab) => {
    const active = tab.dataset.sizeChartTab === name;
    tab.classList.toggle('is-active', active);
    tab.setAttribute('aria-selected', String(active));
    tab.tabIndex = active ? 0 : -1;
  });

  dialog.querySelector('#size-chart-details').hidden = name !== 'details';
  dialog.querySelector('#size-chart-finder').hidden = name !== 'finder';
}

function distanceFromRange(value, [min, max]) {
  if (value < min) return min - value;
  if (value > max) return value - max;
  return 0;
}

function recommendSize(height, weight) {
  const matches = SIZE_DATA.filter(
    (entry) => distanceFromRange(height, entry.height) === 0 && distanceFromRange(weight, entry.weight) === 0
  );

  if (matches.length) return matches[0];

  return SIZE_DATA.reduce((closest, entry) => {
    const entryScore = distanceFromRange(height, entry.height) / 10 + distanceFromRange(weight, entry.weight) / 5;
    const closestScore = distanceFromRange(height, closest.height) / 10 + distanceFromRange(weight, closest.weight) / 5;
    return entryScore < closestScore ? entry : closest;
  });
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-size-chart-open]');
  if (opener && dialog) {
    event.preventDefault();
    lastTrigger = opener;
    setActiveTab('details');
    dialog.showModal();
    dialog.querySelector('[data-size-chart-close]').focus();
    return;
  }

  if (event.target.closest('[data-size-chart-close]') && dialog) {
    dialog.close();
    return;
  }

  const tab = event.target.closest('[data-size-chart-tab]');
  if (tab) setActiveTab(tab.dataset.sizeChartTab);
});

if (dialog) {
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('close', () => lastTrigger?.focus());

  dialog.querySelector('[data-size-chart-finder]').addEventListener('submit', (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const height = Number(data.get('height'));
    const weight = Number(data.get('weight'));
    const result = dialog.querySelector('[data-size-chart-result]');

    if (!height || !weight) {
      result.textContent = 'Enter both height and weight.';
      return;
    }

    const recommendation = recommendSize(height, weight);
    result.textContent = `Recommended size: ${recommendation.size}`;
  });
}
